import React from 'react';
import { useSubscriptionModal } from '../../contexts/SubscriptionModalContext';
import SubscriptionModalContent from './modal/SubscriptionModalContent';
import { X } from '../../utils/icons';
import './subscription-modal.scss';

export const SubscriptionModal: React.FC = () => {
  const { isOpen, mode, closeModal } = useSubscriptionModal();

  // Don't render anything if modal is closed
  if (!isOpen || !mode) return null;

  return (
    <div className="subscription-modal-overlay">
      <div className="subscription-modal-container">
        <button
          className="absolute top-4 right-4 md:top-8 md:right-8 z-[10001] w-9 h-9 md:w-10 md:h-10 inline-flex items-center justify-center bg-transparent border-0 cursor-pointer text-white/70 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--primary)]"
          onClick={closeModal}
          aria-label="Close subscription modal"
          type="button"
        >
          <X className="w-8 h-8" aria-hidden="true" focusable="false" />
        </button>

        {/* Render subscription selection content */}
        <SubscriptionModalContent />
      </div>
    </div>
  );
};

export default SubscriptionModal;
